var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9833 8.48804H11.7185C11.5005 10.1638 10.174 11.4935 8.5 11.717V14.9823C11.9688 14.7373 14.7435 11.9593 14.9833 8.48804Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01675 8.48804C1.25625 11.959 4.03076 14.7373 7.50001 14.9823V11.7163C7.25401 11.6835 7.01126 11.6268 6.77601 11.5455C6.25451 11.3653 5.7755 11.0683 5.381 10.6828C4.97025 10.2818 4.65301 9.78729 4.46226 9.24579C4.37551 8.99979 4.31576 8.74579 4.28226 8.48804H1.01675Z",
    fill: "#26B99A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49979 1.01782C4.03879 1.26207 1.26905 4.02807 1.0183 7.48807H4.28455C4.5123 5.82357 5.83379 4.50557 7.49979 4.28307V1.01782Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1.01782V4.28307C10.166 4.50557 11.4877 5.82357 11.7152 7.48807H14.9815C14.731 4.02832 11.9613 1.26232 8.5 1.01782Z",
    fill: "#F0C419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSections);
export default __webpack_public_path__ + "static/media/Sections.f7bdac88c2ced2adb4162c3915de6ac7.svg";
export { ForwardRef as ReactComponent };